if (!customElements.get('footer-menus')) {
  customElements.define(
    'footer-menus',
    class FooterMenus extends HTMLElement {
      connectedCallback() {
        this.accordions = Array.from(this.querySelectorAll('details'));
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.onMediaChange = this.syncMode.bind(this);
        this.onSummaryClick = this.onSummaryClick.bind(this);

        this.accordions.forEach((details) => {
          const summary = details.querySelector('summary');
          if (summary) summary.addEventListener('click', this.onSummaryClick);
        });

        this.mediaQuery.addEventListener('change', this.onMediaChange);
        this.syncMode();
      }

      disconnectedCallback() {
        this.mediaQuery.removeEventListener('change', this.onMediaChange);
        this.accordions.forEach((details) => {
          const summary = details.querySelector('summary');
          if (summary) summary.removeEventListener('click', this.onSummaryClick);
        });
      }

      isMobile() {
        return this.mediaQuery.matches;
      }

      syncMode() {
        this.accordions.forEach((details) => {
          const body = details.querySelector('.footer__menu-body');
          const summary = details.querySelector('summary');
          if (!body) return;

          if (this.isMobile()) {
            details.removeAttribute('open');
            body.style.height = '0px';
            if (summary) summary.tabIndex = 0;
            return;
          }

          details.setAttribute('open', '');
          body.style.height = 'auto';
          if (summary) summary.tabIndex = -1;
        });
      }

      onSummaryClick(event) {
        event.preventDefault();
        if (!this.isMobile()) return;
        const details = event.currentTarget.closest('details');
        if (!details) return;

        if (details.open) {
          this.closeAccordion(details);
          return;
        }

        this.accordions.forEach((other) => {
          if (other !== details && other.open) this.closeAccordion(other);
        });
        this.openAccordion(details);
      }

      openAccordion(details) {
        const body = details.querySelector('.footer__menu-body');
        if (!body) return;
        details.setAttribute('open', '');
        body.style.height = '0px';
        requestAnimationFrame(() => {
          body.style.height = `${body.scrollHeight}px`;
        });
        const onEnd = (event) => {
          if (event.propertyName !== 'height') return;
          body.style.height = 'auto';
          body.removeEventListener('transitionend', onEnd);
        };
        body.addEventListener('transitionend', onEnd);
      }

      closeAccordion(details) {
        const body = details.querySelector('.footer__menu-body');
        if (!body) return;
        body.style.height = `${body.scrollHeight}px`;
        requestAnimationFrame(() => {
          body.style.height = '0px';
        });
        const onEnd = (event) => {
          if (event.propertyName !== 'height') return;
          details.removeAttribute('open');
          body.removeEventListener('transitionend', onEnd);
        };
        body.addEventListener('transitionend', onEnd);
      }
    }
  );
}
